import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { BusinessInfoService } from 'src/app/POS/POSServices/Business/business-info.service';
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
const swal = require('sweetalert');
@Component({
  selector: 'app-edit-customer-virtual-account',
  templateUrl: './edit-customer-virtual-account.component.html',
  styleUrls: ['./edit-customer-virtual-account.component.scss']
})
export class EditCustomerVirtualAccountComponent implements OnInit {
  city:any;
  state:any;
  
  public stateList: Array<string> = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jammu And Kashmir','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur',
  'Meghalaya', 'Mizoram','Nagaland','Odisha','Punjab','Rajasthan', 'Sikkim','Tamil Nadu','Telangana','Tripura', 'Uttar Pradesh',
  'Uttarakhand','West Bengal','Andaman And Nicobar','Chandigarh','Dadra And Nagar Haveli','Daman And Diu','Delhi','Lakshadweep',
  'Pondicherry',
  ];

  editConfirmAccountNumber = new FormControl("", [Validators.maxLength(17),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,17}$")]);
  AccountNo: any;
  Editaccerrormessage: boolean = false;
  isReadytoUpdateInfo: boolean = false;
  public Notification: Array<string> = ['Yes', 'No'];
  AccZipCode: any;
  CvaPayoutCustomerAccountKey = new FormControl("", [Validators.required]);
  CvaPayoutCustomerkeyId = new FormControl("", [Validators.required]);
  CvaBankCodeType = new FormControl("", [Validators.required]);
  CvaAccountNo = new FormControl("", [Validators.maxLength(17),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,17}$")]);
  CvaBankCode = new FormControl("", [Validators.required, Validators.pattern('^(?!0 )[A-Z]{4}0(?!000000)[A-Z0-9]{6}$')]);
  //public Type: Array<string> = ['RoutingTransitNumber', 'BankSortCodes', 'BsbNumbers', 'SwiftCode', 'MicrCode', 'IfscCode'];
  CvaAddress = new FormControl("", [Validators.required]);
  CvaCity = new FormControl("", [Validators.required]);
  CvaState = new FormControl("", [Validators.required]);
  CvaZipCode = new FormControl("", [Validators.required, Validators.pattern("^(?!000000)[0-9]{6}$")]);
  CvaMobileNotification = new FormControl("", []);
  CvaMobileNo = new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  CvaAccountHolderName = new FormControl("", [Validators.required]);
  CvaEmail = new FormControl("", [Validators.required]);
  CvaEmailNotification = new FormControl("", []);
  CvaPayoutProcessor = new FormControl("", [Validators.required]);
  CvaBankRefereceId = new FormControl("", [Validators.required]);


  // cAccountHolderName:any;
  // AccountHolderName:any
  name: any;
  rows;
  viewid: any;
  public Type: Array<string> = ['RoutingTransitNumber', 'BankSortCodes', 'BsbNumbers', 'SwiftCode', 'MicrCode', 'IFSCCode'];
  constructor(private route: ActivatedRoute, private service: PayoutService,private businessinfo:BusinessInfoService, private commonfunction: CommonFunctionService, private router: Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });

    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.ViewCustomerVirtualAccounDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
      this.rows = result;
      this.AccountNo = result.AccountNo;
      if (this.rows.EmailNotification == 1) {
        this.rows.EmailNotification = "Yes"
      }
      else {
        this.rows.EmailNotification = "No"
      }
      if (this.rows.MobileNotification == 1) {
        this.rows.MobileNotification = "Yes"
      }
      else {
        this.rows.MobileNotification = "No"
      }
      if (this.rows.BankCodeType == 0) {
        this.rows.BankCodeType = "RoutingTransitNumber"
      }
      else if (this.rows.BankCodeType == 1) {
        this.rows.BankCodeType = "BankSortCodes"
      }
      else if (this.rows.BankCodeType == 2) {
        this.rows.BankCodeType = "BsbNumbers"
      }
      else if (this.rows.BankCodeType == 3) {
        this.rows.BankCodeType = "SwiftCode"
      }
      else if (this.rows.BankCodeType == 4) {
        this.rows.BankCodeType = "MicrCode"
      }
      else if (this.rows.BankCodeType == 5) {
        this.rows.BankCodeType = "IfscCode"
      }
    })
  }

  ngOnInit() {
  }
  Editvirtualinfo() {
    let form = {
      PayoutCustomerAccountKeyId: "",
      PayoutCustomerkeyId: "",
      BankCodeType: "",
      AccountNo: "",
      BankCode: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      MobileNotification: 0,
      MobileNo: "",
      AccountHolderName: "",
      Email: "",
      EmailNotification: 0,
      PayoutProcessor: "",
      BankRefereceId: "",
      UpdatedUserName: "",
      MerchantKeyId: 0,
      Id: "",
      Status: "",
      LoginUserId: ''
    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.PayoutCustomerAccountKeyId = this.CvaPayoutCustomerAccountKey.value;
    form.PayoutCustomerkeyId = this.CvaPayoutCustomerkeyId.value;
    form.AccountNo = this.CvaAccountNo.value;
    form.BankCodeType = this.CvaBankCodeType.value;
    form.BankCode = this.CvaBankCode.value;
    //form.MobileNotification = this.CvaMobileNotification.value;
    if (this.CvaMobileNotification.value == "Yes") {
      form.MobileNotification = 1;
    }
    else {
      form.MobileNotification = 0;
    }
    form.Address = this.CvaAddress.value;
    form.City = this.CvaCity.value;
    form.State = this.CvaState.value;
    form.ZipCode = this.CvaZipCode.value;
    //form.EmailNotification = this.CvaEmailNotification.value;
    if (this.CvaEmailNotification.value == "Yes") {
      form.EmailNotification = 1;
    }
    else {
      form.EmailNotification = 0;
    }

    form.MobileNo = this.CvaMobileNo.value;
    form.AccountHolderName = this.CvaAccountHolderName.value;
    form.Email = this.CvaEmail.value;
    form.PayoutProcessor = this.CvaPayoutProcessor.value;
    form.BankRefereceId = this.CvaBankRefereceId.value;
    form.Status = this.rows.Status
    form.Id = this.rows.Id;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.EditVirtualinfo(form).subscribe(result => {

      if (result != null) {

        swal("Updated", "Update Virtualinfo Successfully", "success");
        this.router.navigate(["PayOut/ManageVirtualAccount"]);
      }
    });
  }

  checkaccnumbers() {
    var Eacc = this.CvaAccountNo.value;
    var Ecacc = this.editConfirmAccountNumber.value;
    if (Eacc == "" || Ecacc == "") {
      this.Editaccerrormessage = false;
    }
    else {
      if (Eacc != Ecacc) {
        this.Editaccerrormessage = true;
      }
      else {
        this.Editaccerrormessage = false;
      }

    }
  }


  onKey() {
    this.isReadytoUpdateInfo = true;
  }
  PayoutCustomerAccountKeyIderrors() {
    return this.CvaPayoutCustomerAccountKey.hasError("required")
      ? "Payout Customer keyId is required"
      : "";
  }
  PayoutCustomerkeyIderrors() {
    return this.CvaPayoutCustomerkeyId.hasError("required")
      ? "PayoutCustomerkeyId is required"
      : "";
  }
  BankCodeTypeerrors() {
    return this.CvaBankCodeType.hasError("required")
      ? "BankCodeType is required"
      : "";
  }
  AccountNoerrors() {
    return this.CvaAccountNo.hasError("required")
      ? "AccountNo is required"
      : this.CvaAccountNo.hasError("pattern")
        ? "Enter Valid Account number .It allows only 9 to 17 digits"
        : "";
  }
  editConfirmAccountnumbererrors() {
    return this.editConfirmAccountNumber.hasError("required")
      ? "Confirm AccountNo is required"
      : this.editConfirmAccountNumber.hasError("pattern")
        ? "Enter Valid Confirm Account number .It allows only 9 to 17 digits"
        : "";
  }
  BankCodeerrors() {
    return this.CvaBankCode.hasError("required")
      ? "Bank Code/IFSC Code is required"
      : this.CvaBankCode.hasError('pattern')
        ? 'Bank Code/IFSC Code format should be like eg:AAAA00000001'
        : '';
  }
  AccountHolderNameerrors() {
    return this.CvaAccountHolderName.hasError("required")
      ? "AccountHolderName is required"
      : "";
  }
  Addresserrors() {
    return this.CvaAddress.hasError("required")
      ? "Address is required"
      : "";
  }

  Cityerrors() {
    return this.CvaCity.hasError("required")
      ? "City is required"
      : "";
  }
  Stateerrors() {
    return this.CvaState.hasError("required")
      ? "State is required"
      : "";
  }
  ZipCodeerrors() {
    return this.CvaZipCode.hasError("required")
      ? "ZipCode is required"
      : this.CvaZipCode.hasError("pattern")
        ? "Please Enter valid ZipCode and Must be 6 digit number only"
        : "";
  }
  MobileNoeerrors() {
    return this.CvaMobileNo.hasError('required') ? 'MobileNo is required' :
      this.CvaMobileNo.hasError('min') || this.CvaMobileNo.hasError('max') ? 'Enter valid MobileNo' :
        this.CvaMobileNo.hasError('pattern') ? 'Enter valid MobileNo' : '';
  }
  Emaileerrors() {
    return this.CvaEmail.hasError("required")
      ? "Email is required"
      : this.CvaEmail.hasError("pattern") ? "Enter valid Email Address" : "";

  }

  Getzipcodedetails() {
    this.businessinfo.Zipcodedetails(this.CvaZipCode.value).subscribe(result => {
      if (result != null) {
        this.city = result.CityVillageArea;
        this.state = result.State;
        var pincode = this.state.toLowerCase().split(' ');
        for (var i = 0; i < pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        pincode = pincode.filter(item => item !== '');
        this.state = pincode.join(' ');;
        
      }
      else {
        this.city = "";
        this.state = "";
      }
    });
  }
}